import { ModalSize, MagicConfigMixin } from '@gig/magic-common';
import { __extends, __decorate, __metadata } from 'tslib';
import { Prop, Emit, Component, Mixins } from 'vue-property-decorator';

/**
 * Component used to display content (or page) in a modal dialog. By default
 * has action buttons back and close which allow the user to navigate. Also
 * displays title to indicate what component was injected into a modal dialog.
 */
var ModalComponent = /** @class */ (function (_super) {
    __extends(ModalComponent, _super);
    function ModalComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Emitted when close button is clicked
     */
    ModalComponent.prototype.close = function () {
        return;
    };
    /**
     * Emitted when back arrow is clicked
     */
    ModalComponent.prototype.goBack = function () {
        return;
    };
    __decorate([
        Prop({ type: String, default: ModalSize.DEFAULT }),
        __metadata("design:type", String)
    ], ModalComponent.prototype, "size", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ModalComponent.prototype, "dismissible", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ModalComponent.prototype, "backArrow", void 0);
    __decorate([
        Prop(String),
        __metadata("design:type", String)
    ], ModalComponent.prototype, "backArrowContent", void 0);
    __decorate([
        Prop(Boolean),
        __metadata("design:type", Boolean)
    ], ModalComponent.prototype, "showAsModalOnMobile", void 0);
    __decorate([
        Emit('close'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ModalComponent.prototype, "close", null);
    __decorate([
        Emit('back'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], ModalComponent.prototype, "goBack", null);
    ModalComponent = __decorate([
        Component({
            name: 'ui-modal',
            inheritAttrs: false,
        })
    ], ModalComponent);
    return ModalComponent;
}(Mixins(MagicConfigMixin)));

export default ModalComponent;
